import "./App.css";
import OAuthSuccess from "./pages/OAuthSuccess";
import Home from "./pages/Home";
import OAuthError from "./pages/OAuthError";
import { Routes, Route } from "react-router-dom";
import { AlertProvider } from "./contexts/AlertContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PastIncidents from "./pages/PastIncidents";
import Users from "./pages/Users";
import Analytics from "./pages/Analytics";
import ApplicationHeader from "./components/ApplicationHeader";

function App() {
  return (
    <AlertProvider>
      <div className="app-container">
        <ApplicationHeader className="app-header" />
        <div className="app-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/oauth-success" element={<OAuthSuccess />} />
            <Route path="/oauth-error" element={<OAuthError />} />
            <Route
              path="/past-incidents"
              element={
                <ProtectedRoute allowedRoles={["USER"]}>
                  <PastIncidents />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <ProtectedRoute allowedRoles={["ADMIN"]}>
                  <Analytics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute allowedRoles={["ADMIN", "MODERATOR"]}>
                  <Users />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </div>
    </AlertProvider>
  );
}

export default App;
